export const CARD_BRANDS=['visa', 'mastercard'];